import React, { useState } from 'react';
import Modal from 'react-modal';

const Cabin = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const openModal = (imgSrc) => {
    setCurrentImage(imgSrc);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const images = [
    "/images/Home/homepost.png",
    "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/6621fb7436e74384d85b3eb5_P1814111%20copy-p-1080.jpg",
    "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/6621fb733cc945b04f7b482e_P1803285-p-2000.jpg",
    "/images/Home/slider2.jpeg"
  ];

  return (
    <section className="py-12">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-semibold mb-4 md:mb-6">Inside your suite</h2>
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 md:gap-6">
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Cabin ${index + 1}`}
              className="w-full h-[210px] md:h-64 object-cover rounded-xl transition-transform duration-200 hover:scale-105 will-change-transform cursor-pointer"
              onClick={() => openModal(src)}
            />
          ))}
        </div>
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Zoomed Image"
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75"
        overlayClassName="fixed inset-0 bg-white bg-opacity-75"
      >
        <div className="relative p-4 rounded-lg max-w-3xl mx-auto">
          <img src={currentImage} alt="Zoomed Cabin" className="w-full h-auto object-contain" />
        </div>
        <button onClick={closeModal} className="fixed top-0 right-0 m-4 text-gray-500 hover:text-gray-700 text-4xl">&times;</button>
      </Modal>
    </section>
  );
};

export default Cabin;
